const loadedScripts = {};

export function loadScript(src, id = null) {
  if (loadedScripts[src]) return loadedScripts[src];

  loadedScripts[src] = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    if (id) script.id = id;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return loadedScripts[src];
}

export function loadCSS(href) {
  if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();

  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.onload = resolve;
    document.head.appendChild(link);
  });
}
